import React, { useEffect, useState } from "react";
import { checkUserUrl } from "../Utils/Utils";
import { url } from "../Utils/userAuth";

const WhatsAppApiComponent = () => {
  const domain = window.location.protocol + "//" + window.location.host;
  const domain1 = window.location.hostname;
   const [brandName, setBrandName] = useState("");
  
   useEffect(() => {
       const siteSettings = localStorage.getItem("siteSettings");
       if (siteSettings) {
         const parsed = JSON.parse(siteSettings);
         setBrandName(parsed.brand_name || "");
       }
     }, []);

  // console.log(url)
  return (
    <div className="api-docs">
      <p className=" mt-2 mb-0">
        Sending WhatsApp using {domain1} APIs is a breeze and lightning fast. Simply
        pass the message body, mobile number & {domain1} in the API request to send
        WhatsApp Message instantly.
      </p>
      <h3 className="mt-4">WhatsApp Templates: </h3>
      <p className=" mt-2 mb-0">
        You can also{" "}
        <a href="/dashboard/whatsapp-template-list">create templates</a> in the{" "}
        {domain1} portal and use the <strong>template ID (wid) </strong>in the API
        request. Templates are necessary in case of dynamic content present in
        the message. For example, in order to send an OTP message, you can
        create a template as below:
      </p>
      <p>
        {" "}
        Dear <strong> {`{{1}}`} </strong>, your otp is{" "}
        <strong> {`{{2}}`} </strong> {domain1} automatically adds the dynamic
        values of the Template as API Parameters which can be used to change the
        content delivered to each recipient.
      </p>
      <p className=" mt-2 mb-0">
        Example usage for above template, assuming{" "}
        <strong> whatsaApp Template id (wid) </strong> generated as 101 is as
        follows.
      </p>
      <code>
        {`${
          checkUserUrl(domain)
            ? "https://api.authkey.io/request"
            : `${domain}/restapi/request.php`
        }`}
        ?authkey=<span className="paivariable">{"XXXXXX"}</span>&mobile=
        <span className="paivariable">RecepientMobile</span>&country_code=
        <span className="paivariable">CountryCodeWithoutPlusSign</span>&wid=
        <span className="paivariable">101</span>&1=
        <span className="paivariable">Twinkle</span>&2=
        <span className="paivariable">1234</span>
      </code>
      <p>
        {" "}
        Here, <strong> 'name' </strong> and <strong>'otp'</strong> parameters
        are auto-added to the API and their values shall be replaced in the
        template body {`{...}`}
      </p>
      <h3 className="mt-5">{brandName} Balance: </h3>
      <p>
        To fetch your authkey balance just pass your{" "}
        <strong> {`{#authkey#}`} </strong> as parameter, You can find{" "}
        <strong> {`{#authkey#}`} </strong> into your My Acount {`>`} Profile.
      </p>
      <code>
        {`${
          checkUserUrl(domain)
            ? " https://console.authkey.io/restapi/getbalance.php?authkey="
            : `${domain}/restapi/getbalance.php?authkey=`
        }`}
        <span className="paivariable">authkey</span>
      </code>
      <p>
        <b>GET API To Send Media Document/Image/Video Template with variable</b>
      </p>
      <h3 className="mt-5">API using GET Request [Multimedia]:</h3>
      <code>
        {`${
          checkUserUrl(domain)
            ? " https://console.authkey.io/restapi/request.php?authkey="
            : `${domain}/restapi/request.php?authkey=`
        }`}
        <span className="paivariable">XXXXXX</span>&mobile=
        <span className="paivariable">XXXXXXXXXX</span>&country_code=
        <span className="paivariable">91</span>&wid=
        <span className="paivariable">templateid</span>&template_type=
        <span className="paivariable">media</span>&headerFileName=
        <span className="paivariable">BillDetails</span>&headerData=
        <span className="paivariable">https://abc.pdf</span>
      </code>
      <h3 className="mt-5">API using POST Request:</h3>
      <code>
        {`${
          checkUserUrl(domain)
            ? " https://console.authkey.io/restapi/requestjson.php"
            : `${domain}/restapi/requestjson.php`
        }`}
      </code>
      <h4 className="my-4 text-muted">
        <b>Headers:</b>
      </h4>
      <div class="mt-2 mb-0 ml-5">
        <p>
          <b>Authorization:</b> Basic{" "}
          <pre class="preinline">&lt;Your Authkey&gt;</pre>
        </p>
      </div>
      <div class="mt-0 mb-0 ml-5">
        <p>
          <b>Content-Type:</b> application/json
        </p>
      </div>
      <pre>
        <code>
          {`
          {
              "country_code": "XX",                        // country code without plus (+) sign      
              "mobile": "XXXXXXXXXX",
              "wid": "xxxx",
              "type": "text",
              "bodyValues": {"1":"xxxx","2":"xxxx"},
              "headerValues": {
                "headerFileName": "xyz",
                "headerData":  "https://abc.pdf"
              }
            }
          `}
        </code>
      </pre>
      <h4 className="my-4 text-muted">
        <b>Parameters:</b>
      </h4>
      <p>
        <pre class="preinline">&lt;Your authkey&gt;</pre> = Your {brandName} portal
        authkey
      </p>
      <p>country_code = xx <span style={{float: "right", color: "#888", fontSize: "0.85em"}}>(country code without + sign)</span></p>                                  
      <p>mobile = Mobile Number</p>
      <p>wid = WhatsApp Template ID</p>
      <p>type = text/media</p>
      <p>bodyValues = pass the variables as "1":"value", "2":"value"</p>
      <p>headerFileName = Header</p>
      <p>Name headerData = file full url</p>

      <h3 className="mt-5">Json API Sending Multiple Number upto 200:</h3>
      <code>
        {`${
          checkUserUrl(domain)
            ? " https://console.authkey.io/restapi/requestjson_v2.0.php"
            : `${domain}/restapi/requestjson.php`
        }`}
      </code>
      <h4 className="my-4 text-muted">
        <b>Headers:</b>
      </h4>
      <div class="mt-2 mb-0 ml-5">
        <p>
          <b>Authorization:</b> Basic{" "}
          <pre class="preinline">&lt;Your Authkey&gt;</pre>
        </p>
      </div>
      <div class="mt-0 mb-0 ml-5">
        <p>
          <b>Content-Type:</b> application/json
        </p>
      </div>
      <pre>
        <code>
          <div className="row">
            <div className="col-12">
              <h5 style={{ color: "white" }}>Send Template Without Variable</h5>
              {`
          {
    "version": "2.0",
    "country_code": "91",                                         // country code without plus (+) sign
    "wid": "XXXX",
    "type": "text",
    "data": [
        {
            "mobile": "XXXXXX"
        },
        {
            "mobile": "XXXXXX"
        },
        {
            "mobile": "XXXXXX"
        }
    ]
}
          `}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h5 style={{ color: "white" }}>Send Template With Variable</h5>
              {`
          {
    "version": "2.0",
    "country_code": "91",                                          // country code without plus (+) sign
    "wid": "XXXX",
    "type": "text",
    "data": [
        {
            "mobile": "XXXXXX",
            "bodyValues": {
                "1": "Mr ashish"
            }
        },
        {
            "mobile": "XXXXXX",
            "bodyValues": {
                "1": "Mr suraj"
            }
        },
        {
            "mobile": "XXXXXX",
            "bodyValues": {
                "1": "Mr nitesh"
            }
        }
    ]
}
          `}
            </div>
          </div>
        </code>

        <code>
          <div className="row">
            <div className="col-12">
              <h5 style={{ color: "white" }}>
                Send Media Template Without Variable
              </h5>
              {`
          {
    "version": "2.0",
    "country_code": "91",                                             // country code without plus (+) sign
    "wid": "xxxx",
    "type": "media",
    "data": [
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "xxxx"
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "xxxx"
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "xxxx"
        }
    ]
}

          `}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h5 style={{ color: "white" }}>
                Send Media Template With Variable
              </h5>
              {`
          {
    "version": "2.0",
    "country_code": "91",                                          // country code without plus (+) sign
    "wid": "3733",
    "type": "media",
    "data": [
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr ashish"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr suraj"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr nitesh"
            }
        }
    ]
}
          `}
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <h5 style={{ color: "white" }}>
               Send Media Template With Variable And Dynmaic Button Value
              </h5>
              {`
          {
    "version": "2.0",
    "country_code": "91",                                              // country code without plus (+) sign
    "wid": "3733",
    "type": "media",
    "button_param_value":"sdf766",
    "data": [
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr ashish"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr suraj"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr nitesh"
            }
        }
    ]
}
          `}
            </div>
          </div>

           <div className="row">
            <div className="col-12">
              <h5 style={{ color: "white" }}>
               Send Media Template With Variable And Copy Offer Code
              </h5>
              {`
          {
    "version": "2.0",
    "country_code": "91",                                         // country code without plus (+) sign
    "wid": "3733",
    "type": "media",
    "copy_code_value": "sdf766",
    "data": [
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr ashish"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr suraj"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr nitesh"
            }
        }
    ]
}
          `}
            </div>
          </div>

            <div className="row">
            <div className="col-12">
              <h5 style={{ color: "white" }}>
               Send Media Template With Variable And LTO(Limited Time Offer Copy Code)
              </h5>
              {`
          {
    "version": "2.0",
    "country_code": "91",                                               // country code without plus (+) sign
    "wid": "3733",
    "type": "media",
    "copy_code_value": "sdf766",
    "expiration_time_ms": "",
    "data": [
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr ashish"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr suraj"
            }
        },
        {
            "headerValues": {
                "headerData": "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202411/6734526044003.png"
            },
            "mobile": "XXXX",
            "bodyValues": {
                "1": "Mr nitesh"
            }
        }
    ]
}
          `}
            </div>
          </div>
        </code>
      </pre>
      <h4 className="my-4 text-muted">
        <b>Parameters:</b>
      </h4>
      <p>
        <pre class="preinline">&lt;Your authkey&gt;</pre> = Your {brandName} portal
        authkey
      </p>
      <p>country_code = xx <span style={{float: "right", color: "#888", fontSize: "0.85em"}}>(country code without + sign)</span></p>
      <p>mobile = Mobile Number</p>
      <p>wid = WhatsApp Template ID</p>
      <p>type = text/media</p>
      <p>bodyValues = pass the variables as "1":"value"</p>
      <p>headerFileName = Header</p>
      <p>Name headerData = file full url</p>
      <p>expiration_time_ms = Offer expiry time in Unix time (milliseconds).</p>
      <p>For LTO template type, expiration_time_ms accepts a Unix timestamp in milliseconds.</p>
    </div>
  );
};

export default WhatsAppApiComponent;
